import React from 'react';
import { Switch } from '@headlessui/react';
import { cn } from './_cn';

const toneClass = {
  blue: 'bg-blue-600 dark:bg-sky-500',
  emerald: 'bg-emerald-500 dark:bg-emerald-500',
  rose: 'bg-rose-500 dark:bg-rose-500',
  amber: 'bg-amber-500 dark:bg-amber-500',
};

const ToggleSwitch = ({
  checked,
  onChange,
  tone = 'blue',
  disabled = false,
  ariaLabel,
  className = '',
}) => (
  <Switch
    checked={!!checked}
    disabled={disabled}
    onChange={onChange}
    // Headless UI renders a bare <button role="switch">; without this a screen
    // reader announces it with no name at all. Callers that already wrap the
    // switch in a <Switch.Label> can leave it off.
    aria-label={ariaLabel}
    className={cn(
      'relative inline-flex h-6 w-11 shrink-0 cursor-pointer rounded-full border-2 border-transparent transition-colors duration-200',
      'focus:outline-none focus:ring-2 focus:ring-blue-500/40 focus:ring-offset-2 dark:focus:ring-sky-400/40',
      'disabled:cursor-not-allowed disabled:opacity-60',
      checked ? toneClass[tone] || toneClass.blue : 'bg-slate-200 dark:bg-slate-700',
      className,
    )}
  >
    <span
      aria-hidden
      className={cn(
        'pointer-events-none inline-block h-5 w-5 transform rounded-full bg-white shadow ring-0 transition duration-200',
        checked ? 'translate-x-5' : 'translate-x-0',
      )}
    />
  </Switch>
);

export default ToggleSwitch;
